export const SETALERTMASTERSAVE = "SETALERTMASTERSAVE";
export const SETALERT = "SETALERT";
export const SETTABLE = "SETTABLE";
export const SETUSERLIST = "SETUSERLIST";